import ResultsPieChartSVG from './ResultsPieChartSVG.js';

export default ResultsPieChartSVG;


// WEBPACK FOOTER //
// ./src/shared/components/ResultsPieChartSVG/index.js